import * as types from '../mutation-types'
import adchargeService from '../../services/adcharges'

const state = {
    loading: false,
    errors: null,
    adcharges: [],
}

const actions = {
    getAll({ commit }) {
        commit(types.ADCHARGE_LOADING, true)
        adchargeService.getAll().then(
            response => {

                commit(types.LOAD_ADCHARGES, response.data)
                commit(types.ADCHARGE_LOADING, false)
                commit(types.ADCHARGE_FAILURE, null)
            },
            error => {
                commit(types.ADCHARGE_FAILURE, error)
                commit(types.ADCHARGE_LOADING, false)
            }
        )
    },
    add({ commit }, data) {
        commit(types.ADCHARGE_LOADING, true)
        commit(types.ADCHARGE_FAILURE, null)

        adchargeService.add(data).then(
            response => {
                data.id = response.data.id
                commit(types.ADD_ADCHARGE, data)
                commit(types.ADCHARGE_LOADING, false)

            },
            error => {
                commit(types.ADCHARGE_FAILURE, error)
                commit(types.ADCHARGE_LOADING, false)
            }
        )
    },
    update({ commit }, data) {
        commit(types.ADCHARGE_LOADING, true)
        commit(types.ADCHARGE_FAILURE, null)
        data.adcharge.roles = ["adcharge"]
        adchargeService.update(data.adcharge)
            .then(
                response => {
                    commit(types.UPDATE_ADCHARGE, data)
                    commit(types.ADCHARGE_LOADING, false)

                },
                error => {
                    commit(types.ADCHARGE_FAILURE, error)
                    commit(types.ADCHARGE_LOADING, false)
                }
            )


    },
    delete({ commit }, data) {
        commit(types.ADCHARGE_LOADING, true)
        commit(types.ADCHARGE_FAILURE, null)
        adchargeService.delete(data.adcharge.id)
            .then(
                response => {

                    commit(types.DELETE_ADCHARGE, data)
                    commit(types.ADCHARGE_LOADING, false)

                },
                error => {
                    commit(types.ADCHARGE_FAILURE, error)
                    commit(types.ADCHARGE_LOADING, false)
                }
            )
    }
}

const mutations = {
    [types.ADD_ADCHARGE](state, payload) {
        state.adcharges.unshift(payload);
    },
    [types.LOAD_ADCHARGES](state, payload) {
        state.adcharges = payload
    },
    [types.UPDATE_ADCHARGE](state, payload) {
        Object.assign(state.adcharges[payload.index], payload.adcharge);
    },
    [types.DELETE_ADCHARGE](state, payload) {
        state.adcharges.splice(payload.index, 1)
    },
    [types.ADCHARGE_FAILURE](state, payload) {
        state.errors = payload
    },

    [types.ADCHARGE_LOADING](state, payload) {
        state.loading = payload
    },
}


const getters = {
    ADCHARGES: state => {
        return state.adcharges
    },

    ADCHARGE_ERROR: state => {
        return state.errors
    },

    ADCHARGE_LOADING: state => {
        return state.loading
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/adcharges.js